class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.drawer = document.getElementById("cart-drawer-panel");
    this.overlay = document.getElementById("cart-drawer-overlay");
    this.onBodyClick = this.handleCloseClick.bind(this);
    this.onBodyOpenClick = this.handleOpenClick.bind(this);
    this.renderCart = this.handleRenderCart.bind(this);
    this.removeItem = this.handleRemoveItem.bind(this);

    this.cartItemsContainer = document.getElementById("js-cart-items");

    this.openTriggers = document.querySelectorAll(".js-btn-open-cart");
    this.closeTiggers = document.querySelectorAll(".js-btn-close-cart");

    this.openTriggers.forEach((btn) => {
      btn.addEventListener("click", this.onBodyOpenClick);
    });

    this.closeTiggers.forEach((btn) => {
      btn.addEventListener("click", this.onBodyClick);
    });
  }

  async connectedCallback() {
    await this.loadCart();
  }

  async loadCart() {
    // fetch cart items
    const response = await fetch("/cart.js");
    const cart = await response.json();

    this.renderCart(cart);
  }

  handleRenderCart(cart) {
    // console.log("renderCart", cart);
    // render cart items
    const cart_items = cart.items
      .map((item) => {
        return `<li class="py-6 flex border-b border-dashed border-gray-300">
      <div class="flex-shrink-0 w-24 h-24 border border-gray-200 rounded-md overflow-hidden">
        <img src="${item.image}" alt="${
          item.product_title
        }" class="w-full h-full object-center object-cover">
      </div>
      <div class="ml-4 flex-1 flex flex-col">
        <div>
          <div class="flex justify-between text-sm font-medium leading-0">
            <h3 class="text-gray-900">
              <a href="${item.url}">
                ${item.product_title}
              </a>
            </h3>
            <p class="ml-4 font-bold text-gray-500">
              $${(item.final_line_price / 100.0).toFixed(2)}
            </p>
          </div>
          ${
            item.variant_title
              ? `<p class="mt-1 text-sm font-mono text-gray-500">
            ${item.variant_title}
          </p>`
              : ""
          }
        </div>
        <div class="flex-1 flex items-end font-mono justify-between text-xs mt-4">
          <p class="text-gray-500">
            Qty ${item.quantity}
          </p>
          <div class="flex">
            <button type="button" data-id="${
              item.variant_id
            }" class="js-remove-cart-item font-medium text-red-600 hover:text-red-500">Remove</button>
          </div>
        </div>
      </div>
    </li>`;
      })
      .join("");

    this.cartItemsContainer.innerHTML = cart_items;

    // Set totals
    document.querySelectorAll(".js-cart-total").forEach((field) => {
      field.innerHTML = `$${(cart.total_price / 100.0).toFixed(2)}`;
    });

    // Set cart totals
    document.querySelectorAll(".js-cart-qty").forEach((field) => {
      field.innerHTML = cart.item_count;
    });

    // Add event listeners
    document.querySelectorAll(".js-remove-cart-item").forEach((btn) => {
      btn.addEventListener("click", this.removeItem);
    });
  }

  open() {
    // this.removeAttribute("hidden");
    this.classList.toggle("pointer-events-none");
    this.overlay.classList.remove("opacity-0");
    this.overlay.classList.add("opacity-100");
    this.drawer.classList.remove("translate-x-full");
    this.drawer.classList.add("translate-x-0");

    // this.notification.addEventListener('transitionend', () => {
    //   this.notification.focus();
    //   trapFocus(this.notification);
    // }, { once: true });

    this.overlay.addEventListener("click", this.onBodyClick);
  }

  close() {
    // this.setAttribute("hidden", true);
    this.classList.toggle("pointer-events-none");
    this.overlay.classList.remove("opacity-100");
    this.overlay.classList.add("opacity-0");
    this.drawer.classList.remove("translate-x-0");
    this.drawer.classList.add("translate-x-full");

    this.overlay.removeEventListener("click", this.onBodyClick);

    // removeTrapFocus(this.activeElement);
  }

  async handleRemoveItem(evt) {
    // console.log("evt.target.dataset.id", evt.target.dataset.id);

    const data = {
      updates: {
        [parseInt(evt.target.dataset.id)]: 0,
      },
    };
    const response = await fetch("/cart/update.js", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    // console.log("response", response);
    const cart = await response.json();
    // console.log("remove from cart", cart);

    this.renderCart(cart);
  }

  handleCloseClick(evt) {
    const target = evt.target;

    this.close();
  }

  handleOpenClick(evt) {
    this.open();
  }
}

customElements.define("cart-drawer", CartDrawer);
